import {
  OreStack,
  OreTable,
  OreTableBody,
  OreTableCaption,
  OreTableCell,
  OreTableContainer,
  OreTableRow,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentDefaultConditionsServiceModel } from '@/AutoEnrollment/domain'
import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { useUserData } from '@/User/ui/context'
import { UserType } from '@/User/domain/UserType'

interface Step3ServicesTableProps {
  services: AutoEnrollmentDefaultConditionsServiceModel[]
  disabledState: boolean
}

export const Step3ServicesTable = ({
  services,
  disabledState,
}: Step3ServicesTableProps): JSX.Element => {
  const { t } = useTranslation()
const { userType } = useUserData()
  return (
    <OreTableContainer>
      <OreTable>
        <OreTableCaption
          title={t(AutoEnrollmentTranslation.productsConditions.servicesTable.title)}
          disabled={disabledState}
        />
        <OreTableBody>
          {services?.length
            ? services.map((service, i) => (
              <OreTableRow key={`service-row-${i}`}>
                <OreTableCell align="left">
                  <OreStack space="xsmall">
                    <OreText
                      bold={true}
                      tone={disabledState ? 'neutral-500' : 'neutral-600'}
                    >
                      {service.name}
                    </OreText>
                    {userType === UserType.RESTAURANT &&(

                      <OreText
                      tone={disabledState ? 'neutral-400' : 'neutral-500'}
                      size="text-sm"
                      >
                      {(() => {
                        const conditions =
                        AutoEnrollmentTranslation.productsConditions.servicesTable.conditions
                        const key = (String(service.id) as unknown) as keyof typeof conditions
                        return t(conditions[key] ?? '')
                      })()}
                    </OreText>
                    )}
                  </OreStack>
                </OreTableCell>

                <OreTableCell align="right">
                  <OreText
                    align="right"
                    tone={disabledState ? 'neutral-500' : 'neutral-600'}
                  >
                    {service.value}
                  </OreText>
                </OreTableCell>
              </OreTableRow>
            ))
            : null}
        </OreTableBody>
      </OreTable>
    </OreTableContainer>
  )
}
